import React from "react";
import styles from './DeviceList.module.css';
import DeviceDetail from "../DeviceDetail/DeviceDetail.jsx";

const DeviceList = ({ 
    devices, 
    selectedDevice, 
    onDeviceSelect, 
    onDeviceEdit, 
    handleDelete, 
    showAddForm = true,
    onUpdateDevice 
}) => {
    if (!devices || devices.length === 0) {
        return <div className={styles.noDevices}>No devices available</div>;
    }

    return (
        <div className={styles.deviceListContainer}>
            <div className={styles.deviceList}>
                {devices.map(device => (
                    <div
                        key={device._id}
                        id={`device-${device._id}`}
                        className={`${styles.deviceWrapper} ${
                            selectedDevice?._id === device._id ? styles.selected : ''
                        }`}
                    >
                        <DeviceDetail 
                            device={device} 
                            isSelected={selectedDevice?._id === device._id}
                            onSelect={() => onDeviceSelect && onDeviceSelect(device)}
                            onEdit={onDeviceEdit}
                            handleDelete={handleDelete}
                            onUpdateDevice={onUpdateDevice}
                        />
                    </div>
                ))}
            </div>
            
            {showAddForm && (
                <div className={styles.addDeviceForm}>
                    <form className={styles.form} >
                        <h3 className={styles.formTitle}>Add New Device</h3>
                        
                        <div className={styles.inputGroup}>
                            <label className={styles.label}>Device Name</label>
                            <input 
                                type="text" 
                                className={styles.input}
                                placeholder="Enter device name" 
                                required 
                            />
                        </div>
                        
                        <div className={styles.inputGroup}>
                            <label className={styles.label}>Device Type</label>
                            <select className={styles.select} required>
                                <option value="">Select type</option>
                                <option value="light">Light</option>
                                <option value="signal">Signal</option>
                            </select>
                        </div>
                        
                        <div className={styles.inputRow}>
                            <div className={styles.inputGroup}>
                                <label className={styles.label}>Position X</label>
                                <input 
                                    type="number" 
                                    className={styles.input}
                                    placeholder="X coordinate" 
                                    required 
                                />
                            </div>
                            <div className={styles.inputGroup}>
                                <label className={styles.label}>Position Y</label>
                                <input 
                                    type="number" 
                                    className={styles.input}
                                    placeholder="Y coordinate" 
                                    required 
                                />
                            </div>
                        </div>
                        
                        <button type="submit" className={styles.submitButton}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10"/>
                                <line x1="12" y1="8" x2="12" y2="16"/>
                                <line x1="8" y1="12" x2="16" y2="12"/>
                            </svg>
                            Add Device
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
}

export default DeviceList;